// Elements 
import Footer from './footer';
import Header from './header';
import Contactform from './contact-form'
import Carousel from 'react-bootstrap/Carousel';


// gasp
import gsap from 'gsap'
import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'
import SplitType from 'split-type'
// CSS
import "../clients.css"

// Bootstrap

import Col from 'react-bootstrap/Col';

// Images
import clients_01 from '../assets/clients/clients-01.png'
import clients_02 from '../assets/clients/clients-02.png'
import clients_03 from '../assets/clients/clients-03.png'
import clients_04 from '../assets/clients/clients-04.png'
import downarrow from '../assets/down-arrow.png'

import Chin_01 from '../assets/clientsdata/client_01/client01.webp'
import Chin_02 from '../assets/clientsdata/client_01/client02.webp'

import Brau_01 from '../assets/clientsdata/client_02/client01.webp'
import Brau_02 from '../assets/clientsdata/client_02/client02.webp'

import Druid_01 from '../assets/clientsdata/client_04/client01.webp'
import Druid_02 from '../assets/clientsdata/client_04/client02.jpg'


import Oldmil_01 from '../assets/clientsdata/client_03/client01.webp'
import Oldmil_02 from '../assets/clientsdata/client_03/client02.webp'

function Clients() {

    const lenis = new Lenis({
        duration: 4,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
        direction: 'vertical', // vertical, horizontal
        gestureDirection: 'vertical', // vertical, horizontal, both
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: true,
        touchMultiplier: 2,
        infinite: false,
      })

//get scroll value
lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
console.log({ scroll, limit, velocity, direction, progress })
})

function raf(time) {
lenis.raf(time)
requestAnimationFrame(raf)
}

requestAnimationFrame(raf)


useGSAP(() => {
    let h1 = new SplitType('.h1.is--clients', {
             types: 'chars',
             tagName: 'span'
           });
           gsap.from(h1.chars, {
               y: '100%',
               opacity: 0,
               duration: 0.1,
               ease: 'Second.in',
               stagger: 0.1,
               
             });

             let fadein = gsap.utils.toArray('.anime-scroll')
             fadein.forEach((item, index) => {
             
             let tl = gsap.timeline({
               scrollTrigger: {
               trigger: item,
             //   pin: true,
               start: "top center",
               end: "bottom bottom",
               scrub: 2,
               toggleActions:"restart none none reset",
               }
             });
   
             let animescroll = new SplitType(item, {
               types: 'chars',
               tagName: 'span'
             });
             tl.from(animescroll.chars, {
               opacity: 0.3,
               duration: 0.1,
               ease: 'Second.in',
               stagger: 0.1
               });
             });
})


    return (
        <section className='paint-container clients-container' id="smooth-wrapper">
           <Header/>

           <div className="section-home-hero">
  <div className="padding-custom is--home--hero">
    <div className="hero-bg-wrapper is--home">
      <div className="content-container is--home--hero">
        <a href="#homeintro-1" className="arrow-circle-btn absolute w-inline-block"><img
            src={downarrow}
            loading="lazy" alt={downarrow} className="arrow_img"/></a>
        <h1 className='h1 is--clients'>Our Partners<br/>in Success</h1>
      </div>
    </div>
  </div>
</div>
           <div className="section-home-intro section-scroll-text-animation">
            <div id="homeintro-1" className="padding-custom is--home--intro">
                <div className="home-intro-img-wrapper is--2">
                    <Carousel data-bs-theme="dark">
                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Chin_01}
                        alt="First slide"
                        />
                        
                        </Carousel.Item>
                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Chin_02}
                        alt="Second slide"
                        />
                        
                        </Carousel.Item>
                 </Carousel>
                                
                </div>
             
                <div className="home-intro-container">
                    <div id="Home-Intro" className="content-container">
                        <Col className='col-split-grid'>
                        <Col>
                        <img className="d-block-w-100" src={clients_03} alt="Second slide"></img>
                        </Col>
                         <Col>
                         <h1 className="h1 black _h1lines anime-scroll">
                        Chin Lung Brewery
                        </h1>
                        <p className='p-text _plines map'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-geo-fill" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.3 1.3 0 0 0-.37.265.3.3 0 0 0-.057.09V14l.002.008.016.033a.6.6 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.6.6 0 0 0 .146-.15l.015-.033L12 14v-.004a.3.3 0 0 0-.057-.09 1.3 1.3 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465s-2.462-.172-3.34-.465c-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411"/>
                        </svg> Indiranagar</p>
                        </Col>
                        </Col>
                        <div className="inner-content-wrapper">
                          <p className='p-text _plines anime-scroll'>
                          A Legacy pub in the Bangalore FnB space curating the best of Bangalore pub feels since 1956! Don’t forget to try their crazy IPA and chilli chicken combo.
                          </p>
                        </div>
                                            
                    </div>
                </div>
            </div>

            <div id="homeintro" className="padding-custom is--home--intro">
               
                <div className="home-intro-img-wrapper is--2">
                    <Carousel data-bs-theme="dark">
                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Brau_01}
                        alt="First slide"
                        />
                        
                        </Carousel.Item>
                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Brau_02}
                        alt="Second slide"
                        />
                        
                        </Carousel.Item>
                 </Carousel>
                                
                </div>
             
                <div className="home-intro-container">
                    <div id="Home-Intro" className="content-container">
                        <Col className='col-split-grid'>
                        <Col>
                        <img className="d-block-w-100" src={clients_02} alt={clients_02}></img>
                        </Col>
                         <Col>
                         <h1 className="h1 black _h1lines anime-scroll">
                         Brau Galie
                        </h1>
                        <p className='p-text _plines map'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-geo-fill" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.3 1.3 0 0 0-.37.265.3.3 0 0 0-.057.09V14l.002.008.016.033a.6.6 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.6.6 0 0 0 .146-.15l.015-.033L12 14v-.004a.3.3 0 0 0-.057-.09 1.3 1.3 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465s-2.462-.172-3.34-.465c-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411"/>
                        </svg> Kormangala</p>
                        </Col>
                        </Col>
                        <div className="inner-content-wrapper">
                          <p className='p-text _plines anime-scroll'>
                          India’s first glass brewhouse has landed in Bangalore. Super experiential brewhouse gallery showcasing excellent craft beers and a cuisine for every spice lover.
                          </p>
                        </div>
                        {/* <div className="footer-top-row__footer-social-links">
    <div className="footer-social-icon position-relative start-0 end-0 bottom-0"><a href="/" target="_blank"><svg
                xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-facebook"
                viewBox="0 0 16 16">
                <path
                    d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951">
                </path>
            </svg></a><a href="/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                className="bi bi-twitter" viewBox="0 0 32 32" version="1.1">
                <g id="surface1">
                    <rect x="0" y="0" width="32" height="32"></rect>
                    <path
                        d="M 12.003906 6.125 L 5.1875 6.125 L 13.265625 16.796875 L 5.703125 25.75 L 9.199219 25.75 L 14.917969 18.980469 L 19.996094 25.6875 L 26.8125 25.6875 L 18.496094 14.707031 L 18.511719 14.722656 L 25.671875 6.25 L 22.175781 6.25 L 16.859375 12.542969 Z M 8.949219 7.992188 L 11.070312 7.992188 L 23.050781 23.820312 L 20.929688 23.820312 Z M 8.949219 7.992188 ">
                    </path>
                </g>
            </svg></a><a href="/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                fill="currentColor" className="bi bi-instagram" viewBox="0 0 16 16">
                <path
                    d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334">
                </path>
            </svg></a><a href="/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                <path
                    d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z">
                </path>
            </svg></a></div>
</div> */}
                    </div>
                </div>
            </div>


           
           <div id="homeintro" className="padding-custom is--home--intro">
               
               <div className="home-intro-img-wrapper is--2">
               <Carousel data-bs-theme="dark">
                       <Carousel.Item>
                       <img
                       className="d-block w-100"
                       src={Oldmil_01}
                       alt="First slide"
                       />
                       
                       </Carousel.Item>
                       <Carousel.Item>
                       <img
                       className="d-block w-100"
                       src={Oldmil_02}
                       alt="Second slide"
                       />
                       
                       </Carousel.Item>
                </Carousel>
                               
               </div>
            
               <div className="home-intro-container">
                   <div id="Home-Intro" className="content-container">
                       <Col className='col-split-grid'>
                       <Col>
                       <img className="d-block-w-100" src={clients_04} alt={clients_04}></img>
                       </Col>
                        <Col>
                        <h1 className="h1 black _h1lines anime-scroll">
                        Old Mill Brewery
                       </h1>
                       <p className='p-text _plines map'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-geo-fill" viewBox="0 0 16 16">
                       <path fill-rule="evenodd" d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.3 1.3 0 0 0-.37.265.3.3 0 0 0-.057.09V14l.002.008.016.033a.6.6 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.6.6 0 0 0 .146-.15l.015-.033L12 14v-.004a.3.3 0 0 0-.057-.09 1.3 1.3 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465s-2.462-.172-3.34-.465c-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411"/>
                       </svg> Gunjur</p>
                       </Col>
                       </Col>
                       <div className="inner-content-wrapper">
                         <p className='p-text _plines anime-scroll'> 
                      
A hyperlocal microbrewery coming in hot with fresh and local craft beers to pair well with their diverse Indian culinary menu. Pet, humans and alien friendly atmosphere!

                         </p>
                       </div>
                       {/* <div className="footer-top-row__footer-social-links">
    <div className="footer-social-icon position-relative start-0 end-0 bottom-0"><a href="/" target="_blank"><svg
                xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-facebook"
                viewBox="0 0 16 16">
                <path
                    d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951">
                </path>
            </svg></a><a href="/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                className="bi bi-twitter" viewBox="0 0 32 32" version="1.1">
                <g id="surface1">
                    <rect x="0" y="0" width="32" height="32"></rect>
                    <path
                        d="M 12.003906 6.125 L 5.1875 6.125 L 13.265625 16.796875 L 5.703125 25.75 L 9.199219 25.75 L 14.917969 18.980469 L 19.996094 25.6875 L 26.8125 25.6875 L 18.496094 14.707031 L 18.511719 14.722656 L 25.671875 6.25 L 22.175781 6.25 L 16.859375 12.542969 Z M 8.949219 7.992188 L 11.070312 7.992188 L 23.050781 23.820312 L 20.929688 23.820312 Z M 8.949219 7.992188 ">
                    </path>
                </g>
            </svg></a><a href="/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                fill="currentColor" className="bi bi-instagram" viewBox="0 0 16 16">
                <path
                    d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334">
                </path>
            </svg></a><a href="/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                <path
                    d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z">
                </path>
            </svg></a></div>
</div> */}
                   </div>
               </div>
           </div>


           <div id="homeintro" className="padding-custom is--home--intro">
               
               <div className="home-intro-img-wrapper is--2">
                   <Carousel data-bs-theme="dark">
                       <Carousel.Item>
                       <img
                       className="d-block w-100"
                       src={Druid_01}
                       alt="First slide"
                       />
                       
                       </Carousel.Item>
                       <Carousel.Item>
                       <img
                       className="d-block w-100"
                       src={Druid_02}
                       alt="Second slide"
                       />
                       
                       </Carousel.Item>
                </Carousel>
                               
               </div>
            
               <div className="home-intro-container">
                   <div id="Home-Intro" className="content-container">
                       <Col className='col-split-grid'>
                       <Col>
                       <img className="d-block-w-100" src={clients_01} alt={clients_01}></img>
                       </Col>
                        <Col>
                        <h1 className="h1 black _h1lines anime-scroll">
                        Druid Garden
                       </h1>
                       <p className='p-text _plines map'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-geo-fill" viewBox="0 0 16 16">
                       <path fill-rule="evenodd" d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.3 1.3 0 0 0-.37.265.3.3 0 0 0-.057.09V14l.002.008.016.033a.6.6 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.6.6 0 0 0 .146-.15l.015-.033L12 14v-.004a.3.3 0 0 0-.057-.09 1.3 1.3 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465s-2.462-.172-3.34-.465c-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411"/>
                       </svg> Sahakarnagar</p>
                       </Col>
                       </Col>
                       <div className="inner-content-wrapper">
                         <p className='p-text _plines anime-scroll'> 
                            India’s first Czech microbrewery with the largest lagering capacity in India. Capable to mature for 2 months or more to create a well-rounded variety of lagers and approachable craft beers.
                         </p>
                       </div>
                   
                   </div>
               </div>
           </div>
           
        </div>
        <Contactform/>
           <Footer/>
        </section>
    )}

export default Clients;    